import React, { useState } from "react";
import styled from "styled-components";
import { MIN_MORNITOR_WIDTH } from "../../../../components/constants";
import Modal from "../../../../components/molecures/Modals/Modal";
import { theme } from "../../../../theme";
import { ReactComponent as PreviewLeft } from "../../../../assets/icons/PreviewLeft.svg";
import { ReactComponent as PreviewRight } from "../../../../assets/icons/PreviewRight.svg";
import { Media } from "../../../../model/Media";

interface Props {
  image: string;
  folder: string;
  medias: Media[];
}
interface StyleProps {
  image: string;
  folder: string;
}
const ImageModal: React.FC<Props> = ({ image, folder, medias }) => {
  const [page, setPage] = useState(
    medias.map((val) => val.fileName).indexOf(image) + 1
  );
  const [src, setSrc] = useState(image);
  return (
    <Modal title="이미지 자세히 보기" width={700} isNoFooter>
      <ModalContainer>
        <ImageWrapper>
          <Image image={src} folder={folder} />
        </ImageWrapper>
        <CustomFooter>
          {medias.length > 1 && (
            <CustomNav>
              <CustomNavBtnWrapper
                onClick={() => {
                  const nextPage = page === 1 ? medias.length : page - 1;
                  setPage(nextPage);
                  setSrc(medias[nextPage - 1].bufferFullUrl);
                }}
              >
                <PreviewLeft />
              </CustomNavBtnWrapper>

              <CustomPagination>{`${page}/${medias.length}`}</CustomPagination>

              <CustomNavBtnWrapper
                onClick={() => {
                  const nextPage = page === medias.length ? 1 : page + 1;
                  setPage(nextPage);
                  setSrc(medias[nextPage - 1].bufferFullUrl);
                }}
              >
                <PreviewRight />
              </CustomNavBtnWrapper>
            </CustomNav>
          )}
        </CustomFooter>
      </ModalContainer>
    </Modal>
  );
};
export default ImageModal;
const ImageWrapper = styled.div`
  max-height: 456px;
  min-height: 456px;
  width: 100%;
  background-color: ${theme.colors.gray1};
`;
const Image = styled.div<StyleProps>`
  width: 100%;
  max-height: 456px;

  min-height: 456px;
  background-image: ${({ image }) => `url(${image})`};
  background-size: contain;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  background-color: ${theme.colors.gray1};
  @media only screen and (max-width: ${MIN_MORNITOR_WIDTH}) {
    max-width: 160px;
    max-height: 160px;
    justify-content: space-between;
  }
`;
const ModalContainer = styled.div`
  background-color: ${theme.colors.gray1};
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  border-radius: 0px 0px 8px 8px;
`;
const CustomFooter = styled.div`
  background: ${theme.colors.gray1};
  height: 48px;
  border-radius: 0px 0px 8px 8px;
  width: 100%;
  display: flex;
  justify-content: center;
`;
const CustomNav = styled.div`
  max-width: 310px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 48px;
  width: 100%;
  color: white;
  stroke: white;
`;
const CustomPagination = styled.div`
  color: white;

  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 24px;
`;
const CustomNavBtnWrapper = styled.div`
  cursor: pointer;
`;
